<template>
  <Layout>
    <PageHeader
      :dir="$i18n.locale == 'ar' ? 'rtl' : ''"
      :title="$t('branch_sites.title')"
    />

    <button
      @click="addSite"
      type="button"
      data-bs-toggle="modal"
      data-bs-target="#add-account"
      class="btn btn-primary mb-4 float-end"
    >
      {{ $t("branch_sites.add") }}
    </button>
    <table
      style="margin-top: 29px"
      class="table"
      :dir="$i18n.locale == 'ar' ? 'rtl' : ''"
    >
      <thead>
        <tr class="text-light" style="background-color: #2a3042 !important">
          <th scope="col">{{ $t("branch_sites.name_en") }}</th>
          <th scope="col">{{ $t("branch_sites.name") }}</th>
          <th scope="col">{{ $t("branch_sites.addr") }}</th>
          <th scope="col"></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="site in branch_sites" :key="site">
          <td scope="col">{{ site?.name_en }}</td>
          <td scope="col">{{ site?.name }}</td>
          <td scope="col">{{ site?.addr }}</td>
          <td scope="col ">
            <div class="d-flex gap-2">
              <button
                @click="
                  sub_locations_modal.show();
                  getSubLocation(site);
                "
                style="margin-inline-end: 4px"
                class="btn btn-primary btn-md"
                role="button"
              >
                {{ $t("popups.profile") }}
              </button>
              <button
                class="btn btn-success"
                data-bs-toggle="modal"
                @click="edit(site)"
                data-bs-target="#edit-account"
              >
                {{ $t("tree.edit") }}
              </button>
              <button class="btn btn-danger" @click="deleteSite(site)">
                {{ $t("tree.delete") }}
              </button>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
    <!--Start SubClasses Modal-->
    <div
      class="modal fade"
      id="subLocationsModal"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
      :dir="$i18n.locale == 'ar' ? 'rtl' : ''"
    >
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">
              {{
                $i18n.locale == "en"
                  ? "Sub Location of " + sub_location?.name_en
                  : "المواقع الفرعية ل" + sub_location?.name
              }}
            </h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              style="margin: 0"
            ></button>
          </div>

          <div class="modal-body">
            <div class="row">
              <div class="card">
                <div class="card-body">
                  <div class="row">
                    <div class="col-6"></div>
                    <div
                      class="col-6"
                      style="display: flex; justify-content: flex-end"
                    >
                      <button
                        @click="addSubLocation()"
                        type="button"
                        class="btn btn-light float-end mb-4"
                      >
                        <span
                          class="bx bxs-plus-circle float-end fa-2x"
                          style="color: #2a3042 !important"
                        ></span>
                      </button>
                    </div>
                  </div>
                  <div class="table-responsive">
                    <table
                      :dir="$i18n.locale == 'ar' ? 'rtl' : 'ltr'"
                      class="table table-striped table-hover mb-0 mt-4"
                    >
                      <thead>
                        <tr
                          class="text-light"
                          style="background-color: #2a3042 !important"
                        >
                          <th scope="col">{{ $t("fixed_assets.id") }}</th>
                          <th scope="col">{{ $t("fixed_assets.label") }}</th>
                          <th scope="col">{{ $t("fixed_assets.label_en") }}</th>

                          <th scope="col"></th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(sub_location, index) in subLocations"
                          :key="sub_location"
                          class=""
                        >
                          <td>{{ index + 1 }}</td>
                          <td>{{ sub_location?.name }}</td>
                          <td>{{ sub_location?.name_en }}</td>

                          <td>
                            <a
                              style="margin-inline-end: 4px"
                              class="btn btn-primary btn-md"
                              @click="editSubLocation(sub_location)"
                              role="button"
                              >{{ $t("popups.edit") }}</a
                            >
                            <a
                              class="btn btn-danger btn-md"
                              href="javascript: void(0);"
                              role="button"
                              @click="deleteSubLocation(sub_location)"
                              >{{ $t("popups.delete") }}</a
                            >
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--End SubClasses Modal-->
  </Layout>
</template>
<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import { Modal } from "bootstrap";

export default {
  page: {
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      branch_sites: [],
      sub_location: {},
      subLocations: [],
      sub_locations_modal: {},
    };
  },
  methods: {
    deleteSite(site) {
      this.popup
        .confirm({
          title: "popups.confirm",
          msg: "popups.deletemsg",
        })
        .then((resp) => {
          if (resp) {
            this.http
              .post("level-one-chart-of-accounts/delete-branch-site", {
                id: site.id,
              })
              .then(() => {
                this.get();
              });
          }
        });
    },
    get() {
      this.http
        .post("level-one-chart-of-accounts/get-branch-sites", {})
        .then((resp) => {
          console.log(resp.data);
          this.branch_sites = resp.data;
        });
    },
    getSubLocation(sub_location) {
      this.sub_location = sub_location;
      console.log("step 218 :", sub_location);

      this.http
        .get(
          "level-one-chart-of-accounts/branch-sub-sites/" + sub_location.id,
          {}
        )
        .then((res) => {
          this.subLocations = res.data;
        });
    },

    addSite() {
      var data = {
        title: "popups.addBranchSite",
        inputs: [
          {
            model: "name",
            type: "text",
            label: this.$t("branch_sites.name"),
            restrictions: { required: true },
          },

          {
            model: "name_en",
            type: "text",
            label: this.$t("branch_sites.name_en"),
            restrictions: { required: true },
          },

          { model: "addr", type: "text", label: this.$t("branch_sites.addr") },
        ],
        buttons: [
          {
            text: "popups.add",
            closer: true,
            validate: true,
            color: "primary",
            handler: (obj) => {
              this.http
                .post("level-one-chart-of-accounts/add-branch-site", obj)
                .then(() => {
                  this.get();
                });
            },
          },
          {
            text: "popups.cancel",
            closer: true,
            color: "danger",
            handler: () => {
              console.log("Like Clicked");
            },
          },
        ],
      };
      this.popup.modal(data);
    },
    edit(site) {
      var data = {
        title: "popups.editBranchSite",
        inputs: [
          {
            model: "name",
            type: "text",
            value: site.name,
            label: this.$t("branch_sites.name"),
          },

          {
            model: "name_en",
            type: "text",
            value: site.name_en,
            label: this.$t("branch_sites.name_en"),
          },
          {
            model: "addr",
            type: "text",
            value: site.addr,
            label: this.$t("branch_sites.addr"),
          },
        ],
        buttons: [
          {
            text: "popups.edit",
            closer: true,
            color: "primary",
            handler: (obj) => {
              obj.id = site.id;
              this.http
                .post("level-one-chart-of-accounts/edit-branch-site", obj)
                .then(() => {
                  this.get();
                });
            },
          },
          {
            text: "popups.cancel",
            closer: true,
            color: "danger",
            handler: () => {
              console.log("Like Clicked");
            },
          },
        ],
      };
      this.popup.modal(data);
    },
    editSubLocation(sub_location) {
      var data = {
        title: "popups.edit",
        inputs: [
          {
            model: "name",
            type: "text",
            label: "fixed_assets.label",
            value: sub_location.name,
          },
          {
            model: "name_en",
            type: "text",
            label: "fixed_assets.label_en",
            value: sub_location.name_en,
          },
        ],
        buttons: [
          {
            text: "popups.edit",
            closer: true,
            validate: true,
            color: "primary",
            handler: (obj) => {
              this.http
                .put(
                  "level-one-chart-of-accounts/branch-sub-sites",
                  sub_location.id,
                  obj
                )
                .then(() => {
                  this.getSubLocation(this.sub_location);
                });
            },
          },
          {
            text: "popups.cancel",
            closer: true,
            color: "danger",
            handler: () => {
              console.log("Like Clicked");
            },
          },
        ],
      };
      this.popup.modal(data);
    },
    deleteSubLocation(sub_location) {
      var data = {
        title: "popups.delete",
        msg: "popups.delmessage",
      };
      this.popup.confirm(data).then((resp) => {
        if (resp) {
          this.http
            .delete(
              "level-one-chart-of-accounts/branch-sub-sites",
              sub_location.id
            )
            .then(() => {
              this.getSubLocation(this.sub_location);
            });
        }
      });
    },
    addSubLocation() {
      var data = {
        title: "popups.add",
        inputs: [
          { model: "name", type: "text", label: "fixed_assets.label" },
          { model: "name_en", type: "text", label: "fixed_assets.label_en" },
        ],
        buttons: [
          {
            text: "popups.add",
            closer: true,
            validate: true,
            color: "primary",
            handler: (obj) => {
              obj.branch_id = this.branch_id;
              this.http
                .post(
                  "level-one-chart-of-accounts/branch-sub-sites/" +
                    this.sub_location.id,
                  obj
                )
                .then((res) => {
                  if (res.status) this.getSubLocation(this.sub_location);
                });
            },
          },
          {
            text: "popups.cancel",
            closer: true,
            color: "danger",
            handler: () => {
              console.log("Like Clicked");
            },
          },
        ],
      };
      this.popup.modal(data);
    },
  },
  mounted() {
    this.sub_locations_modal = new Modal("#subLocationsModal");
    this.get();
  },
};
</script>
